import React from 'react';
import type { IPersonStatus } from '~/utils/interface/map';
import { getJourneySegmentTypeColor, JourneySegmentType } from '../constants/segmentTypeColors';
import { useJourneyPersonStatuses } from '../context/JourneyPersonStatusContext';

const PIN_BODY_PATH =
  'M18.002 2.5C23.5049 2.50011 28.7455 5.75828 30.9336 10.873C32.9603 15.6108 31.8832 19.6357 29.5654 23.1465C27.2723 26.6198 23.725 29.6466 20.7686 32.415C20.0239 33.1123 19.0315 33.4999 18.002 33.5C16.9723 33.5 15.9801 33.1123 15.2354 32.415L15.2344 32.4141C12.2867 29.6374 8.73761 26.6132 6.44238 23.1445C4.1218 19.6375 3.04008 15.6169 5.06934 10.873C7.25742 5.75819 12.4989 2.5 18.002 2.5Z';

const PIN_INNER_CIRCLE_PATH =
  'M23.25 16.5C23.25 19.3995 20.8995 21.75 18 21.75C15.1005 21.75 12.75 19.3995 12.75 16.5C12.75 13.6005 15.1005 11.25 18 11.25C20.8995 11.25 23.25 13.6005 23.25 16.5Z';

interface MapBackLocationIconProps {
  fill: string;
  className?: string;
}

export const MapBackLocationIcon: React.FC<MapBackLocationIconProps> = ({ fill, className }) => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden
  >
    <ellipse cx='18' cy='32.5' rx='9' ry='2.5' fill='white' />
    <path d={PIN_BODY_PATH} fill={fill} stroke='white' />
    <path d={PIN_INNER_CIRCLE_PATH} fill='white' />
  </svg>
);

interface MapBackLocationTypeIconProps {
  type: JourneySegmentType;
  className?: string;
  personStatuses?: IPersonStatus[];
}

export const MapBackLocationTypeIcon: React.FC<MapBackLocationTypeIconProps> = ({
  type,
  className,
  personStatuses: personStatusesProp,
}) => {
  const personStatusesFromContext = useJourneyPersonStatuses();
  const personStatuses = personStatusesProp ?? personStatusesFromContext;
  const fill = getJourneySegmentTypeColor(type, personStatuses);

  return <MapBackLocationIcon fill={fill} className={className} />;
};
